import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import MfaSmsChallengeForm from "./components/MfaSmsChallengeForm";
import { useMfaSmsChallengeManager } from "./hooks/useMfaSmsChallengeManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function MfaSmsChallengeScreen() {
    // Extracting attributes from hook made out of MfaSmsChallenge instance of Auth0 React ACUL SDK
    const { mfaSmsChallenge, texts, locales } = useMfaSmsChallengeManager();

    applyAuth0Theme(mfaSmsChallenge);
    return (
        <AuthLayout title={texts?.pageTitle || locales.page.title}>

            <MfaSmsChallengeForm />
            </AuthLayout>
    );
}

export default MfaSmsChallengeScreen;
